import {
  SET_GEOFENCE_PACKAGES,
  SET_CURRENT_STEP,
  SET_IN_PROGRESS_PACKAGE,
  SET_PACKAGE_STATUS,
  SET_POLLER,
  SET_FINAL_PACKAGE,
  SET_FILE_CONTENT,
  SET_PACKAGE_CREATION_ERROR,
  RESET_PACKAGE_CREATION_FLOW,
  SET_GEOFENCE_PACKAGE_SIZE,
} from "../types";

export const STEPS = [
  "VERSION_DIALOG",
  "WARMING_UP",
  "IN_PROGRESS",
  "PACKAGE_COMPLETE",
  "DOWNLOADING_GEOJSON",
  "GEOJSON_DOWNLOAD_COMPLETE",
  "DOWNLOADING_RULECHAIN",
  "RULECHAIN_DOWNLOAD_COMPLETE",
  "DONE",
  "FAILURE",
].reduce((final, current) => ({ ...final, [current]: current }), {});

export default (state, action) => {
  switch (action.type) {
    case SET_GEOFENCE_PACKAGES:
      return {
        ...state,
        ...action.payload,
      };
    case SET_CURRENT_STEP:
      return {
        ...state,
        previousStep: state.currentStep,
        currentStep: action.payload,
      };
    case SET_IN_PROGRESS_PACKAGE:
      return {
        ...state,
        taskId: action.payload.task_id,
      };
    case SET_PACKAGE_STATUS:
      return {
        ...state,
        packageStatus: action.payload,
      };
    case SET_POLLER:
      return {
        ...state,
        poller: action.payload,
      };
    case SET_FINAL_PACKAGE:
      return {
        ...state,
        finalPackage: action.payload,
      };
    case SET_FILE_CONTENT:
      return {
        ...state,
        fileContentToSave: action.payload,
      };
    case SET_PACKAGE_CREATION_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case RESET_PACKAGE_CREATION_FLOW:
      return {
        ...state,
        ...action.payload,
      };
    case SET_GEOFENCE_PACKAGE_SIZE:
      return {
        ...state,
        packageSize: action.payload,
      };
    default:
      return state;
  }
};
